import { AnimatePresence } from '@legendapp/motion';
import { observer } from 'mobx-react-lite';
import styled, { css } from 'styled-components/native';

import { FloorMapAnimatedWrapper } from './Components/FloorMapAnimatedWrapper';
import { useFloorMapPresenter } from './FloorMapPresenter';
import { useFloorMapSizer } from './FloorMapSizer';
import { MapLandscape } from './Layouts/MapLandscape';
import { MapPortrait } from './Layouts/MapPortrait';
import OwnableTheme from '@Theme';

export const FloorMap = observer(function FloorMap() {
  const { extendedMapVisible, setExtendedMapVisible } = useFloorMapPresenter();
  const { mapOrientation } = useFloorMapSizer();
  return (
    <StyledOverlay
      onPress={() => {
        setExtendedMapVisible(false);
      }}
      pointerEvents={extendedMapVisible ? 'auto' : 'none'}
      mapVisible={extendedMapVisible}
    >
      <AnimatePresence>
        <FloorMapAnimatedWrapper>
          {/* TODO: refactor these Landscape and MapPortrait layouts so they can be easier to refactor. Try to use as much as possible CSS-layout rules instead of JS calculations */}
          {mapOrientation === 'landscape' && <MapLandscape />}
          {mapOrientation === 'portrait' && <MapPortrait />}
        </FloorMapAnimatedWrapper>
      </AnimatePresence>
    </StyledOverlay>
  );
});

const StyledOverlay = styled.Pressable<{ mapVisible: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ mapVisible }) =>
    mapVisible &&
    css`
      background-color: ${OwnableTheme.colors.modalShadowDark};
      backdrop-filter: blur(6px);
    `}
`;
